import { Head, Layout, Title } from '@/components'

export default function Cookies() {
  return (
    <Layout className="pt-16 pb-24 sm:pb-48 px-6  sm:px-6 lg:px-8">
      <Head title="Goodbye" description="Good Neighbour is shutting down." />
      <div className="mx-auto max-w-screen-md">
        <Title as="h1" size="2xl">
          Ok bye.
        </Title>
        <article className="prose lg:prose-lg prose-zinc mt-12 dark:prose-invert font-medium">
          <p className="text-3xl font-medium leading-relaxed">
            tldr; You can still read reviews, but you can't add any more. Good Neighbour is becoming readonly because of
            the cost and time needed to maintain it.
          </p>
          <p>
            Good Neighbour is now readonly. There is no ability to login, signup, edit, delete, comment or review your
            apartment. If you need something deleted, updated, or changed, please email me at{' '}
            <a href="mailto:drew@reallygood.work">drew@reallygood.work</a>.
          </p>
          <p>
            I love Good Neighbour deeply. It's been a part of my life for almost 7 years. I've poured hours into the
            project but I've got to let it go. Someone with a different skill set needs to take it over.
          </p>
          <p>
            Selling the monetary and intrinsic value in bringing transparency to the rental market is something I'm
            simply not able to invest in doing. We unfortunately live in a capitalist culture and while we empathize
            with rental issues, there is no immediate benefit to creating accountability. I've never had the desire to
            make Good Neighbour profitable while compromising the needs of the renter.
          </p>
          <p>
            I am a maker, artist, individual contributor, whatever. I coded, designed, and wrote everything on the site
            because it just comes naturally to me to make. However, my dream is not being a CEO. In fact, it's the last
            thing I want in my career. Blame that on punk music.
          </p>
          <p>
            Frankly, it's tiring hearing, "where is the review site for tenants?". It exists, it's called credit checks,
            background checks, and references. If you're a landlord, you should be doing these things. If you're not,
            well, you're not a good landlord. So I'm going to make you better.
          </p>
          <p>
            I'm shifting my focus to sharing my passion for UI Design and Development with others and migrating never
            released Good Neighbour product features to a new product called <a href="https://tadarent.com/">Tada!</a>.
          </p>{' '}
          <p>
            {' '}
            It's a set of tools that will help small landlords manage their rental properties. It's a tool that will
            help you be a better landlord. It's a tool that will help you be a better person.
          </p>
          <p>
            These tools will be open-source and free because I'm in the business of making cool shit. They will be an
            extension of many of the features I designed and built for Good Neighbour, but deemed the wrong fit for the
            audience.
          </p>
          <p>
            If you or anyone you know wants Good Neighbour, reach out to me{' '}
            <a href="mailto:drew@reallygood.work">drew@reallygood.work</a>. The codebase, the branding, the domain, the
            database, the reviews - it can all be yours. I'd love to see it live on, but I ask to be compensated for my
            work. So no freebies. If possible, I'll take the money to pay my taxes for a year of freelancing, and donate
            the rest to a food bank. I'll even help you get it up and running.
          </p>
          <p>Some details about the project:</p>
          <ul>
            <li>2029 Users</li>
            <li>550+ Rental Units with reviews</li>
            <li>NextJS Application with TypeScript and Tailwind</li>
            <li>Postgres</li>
            <li>Zero Debt</li>
          </ul>
          <p>
            If no one wants it - whatever. It's just going to live on the internet as a resource for future renters.
            Also, a pretty cool feather in my cap.
          </p>
          <p>
            To all the people who have used Good Neighbour, I want to say thank you. Your support and your stories have
            consistently given me purpose when I've questioned the work I'm doing. I hope that you've found a place to
            feel safe and at home.
          </p>
          <p>Thank you most importantly to Samaneh, Ryan and Mike for taking a chance with me.</p>
          <p>Take care of each other. ❤️</p>
          <p className="text-2xl font-bold mb-0">Drew Minns.</p>
          <p className="mt-0">
            <a href="https://reallygood.work">https://reallygood.work</a>
          </p>
        </article>
      </div>
    </Layout>
  )
}
